// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"breadcrumb-bar-module--wrapper--223ql","container":"breadcrumb-bar-module--container--2QMkY"};